import styled from "styled-components";
import { colors } from "styles/theme";

export const TransferStatusCardWrapper = styled.div`
  .accepted-card {
    color: ${colors.green};
  }

  .declined-card {
    color: ${colors.red};
  }

  .pending-card {
    color: ${colors.yellow};
  }

  .removed-card {
    color: ${colors.gray};
  }

  .block-card {
    background: ${colors.lighterBlack};
    padding: 5px 10px;
    border-radius: 15px;
  }
`;
